import { version } from '@env/version';
import { v4 as uuid } from 'uuid';

export const silenceConsole = () => {
  try {
    const isApp = document.location.href.includes('app.23d');
    const forceEnable = document.location.href.includes('log23');

    if (isApp && !forceEnable) {
      // silencio
      console.log = (...args) => {};
      console.error = (...args) => {};
    }
  } catch (error) {
    console.log('[silenceConsole] error', error);
  }
};

export const logAppVersion = () => {
  const versionHash = `#${version.revision.substring(0, 7)}`;
  const sessionHash = `23s-${uuid()}`;
  const infoLog = [`version: ${versionHash}`];
  const match = document.location.href.match(/\/(editor|embed)\/([^#\/]+)/);
  const slug = match?.[2];
  if (slug) {
    infoLog.push(`slug: ${slug}`);
  }
  //@ts-ignore
  const logo: any =
    " ____  _____     _                               \r\n|___ \\|___ /  __| | ___  __ _ _ __ ___  ___  ___ \r\n  __) | |_ \\ / _` |/ _ \\/ _` | '__/ _ \\/ _ \\/ __|\r\n / __/ ___) | (_| |  __/ (_| | | |  __/  __/\\__ \\\r\n|_____|____/ \\__,_|\\___|\\__, |_|  \\___|\\___||___/\r\n                        |___/                    ";

  console.log('__________________________________________________');
  console.log(logo);
  console.log(`%c${infoLog.join(', ')}`, 'font-family:monospace; font-weight:bold; font-size: 20px');
  console.log('__________________________________________________');
};
